import React, { useState } from "react";
import { Typography, Collapse } from "@mui/material";
import HyroIconButton from "@hyro-components/hyro-icon-button/HyroIconButton";
import { ICON_BUTTON_VARIANTS, ICON_BUTTON_SIZES } from "@hyro-components/hyro-icon-button/HyroIconButton.consts";
import CopyIcon from "src/icons/CopyIcon";
import ChevronDownIcon from "src/icons/ChevronDown";
import { StyledWrapper, StyledHeaderStack, StyledContentBox } from "./ErrorMessageCollapsible.styles";
import CopyPopper from "@hyro-components/CopyPopper";

const ErrorMessageCollapsible = ({ errorMessage, ...props }) => {
  const [isErrorExpanded, setIsErrorExpanded] = useState(true);

  return (
    <StyledWrapper {...props}>
      <StyledHeaderStack>
        <HyroIconButton
          sx={{ ml: -1 }}
          variant={ICON_BUTTON_VARIANTS.CLEAR}
          size={ICON_BUTTON_SIZES.XLARGE}
          hasHoverStyle={false}
          onClick={() => setIsErrorExpanded(!isErrorExpanded)}
        >
          <ChevronDownIcon
            strokeOpacity={1}
            style={{
              transform: isErrorExpanded ? "rotate(0deg)" : "rotate(180deg)",
              transition: "transform 0.2s ease-in-out"
            }}
          />
        </HyroIconButton>
        <Typography variant="subtitle2" sx={{ flex: 1 }}>Error message</Typography>
        <CopyPopper copyText={errorMessage}>
          <HyroIconButton
            variant={ICON_BUTTON_VARIANTS.CLEAR}
            size={ICON_BUTTON_SIZES.LARGE}
          >
            <CopyIcon strokeOpacity={1} />
          </HyroIconButton>
        </CopyPopper>
      </StyledHeaderStack>

      <Collapse in={isErrorExpanded}>
        <StyledContentBox>
          <Typography variant="caption">{errorMessage}</Typography>
        </StyledContentBox>
      </Collapse>
    </StyledWrapper>
  );
};

export default ErrorMessageCollapsible;
